var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"headerSty"},[_c('div',{staticClass:"headerTime"},[_c('p',[_vm._v(" 剩余时间: ")]),_c('p',[_vm._v(" "+_vm._s(_vm.timeShow)+" ")])]),_c('div',[_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.submitSubject}},[_vm._v("提交试卷")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }